import { Directive, ElementRef, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { importLibrary, setOptions } from "@googlemaps/js-api-loader";
import _once from "lodash/fp/once";
import { take, tap } from "rxjs";

import { Environment, ENVIRONMENT_TOKEN } from "@intocare/environments";
import { LanguageService } from "@intocare/language";

/** Set the Google Maps API options, which can only be set once! */
const setGoogleMapsApiOptions = _once((options: { key: string; language: string }) => {
	setOptions({ key: options.key, v: "weekly", libraries: ["places"], language: options.language });
});

@Directive({
	selector: "[icAutocompletionPlace]",
	standalone: false,
})
export class AutocompletionPlaceDirective implements OnInit {
	private environment = inject<Environment>(ENVIRONMENT_TOKEN);

	@Input() options: any;
	@Output() selectedPlace = new EventEmitter();

	private el = inject(ElementRef);
	private languageService = inject(LanguageService);

	async ngOnInit() {
		this.languageService.language$
			.pipe(
				take(1),
				tap(async (language) => {
					setGoogleMapsApiOptions({ key: this.environment.googleApi, language });

					const places = await importLibrary("places");

					const options = this.options ? this.options : { types: ["geocode"] };

					const autocomplete = new places.Autocomplete(this.el.nativeElement, options);

					autocomplete.addListener("place_changed", () => {
						const place = autocomplete.getPlace();
						this.selectedPlace.emit(place);
					});
				}),
			)
			.subscribe();
	}
}
